export default __webpack_public_path__ + "static/media/emailNetworking.png.webp";